<template>
  <div>
    <Banner heading="Deep Links" style="height: 120px" class="ma-0" />

    <v-container fluid>
      <v-layout>
        <v-flex>
          <v-row justify="center" v-if="this.$route.params.displayAlert">
            <v-col cols="9" class="pt-0">
              <v-alert text dismissible type="success" elevation="2" border="left" color="green">
                <span class="text--primary"><strong>Deep link created successfully!</strong></span>
              </v-alert>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="9" align="right" class="pt-0">
              <v-btn class="text-none" color="primary" large @click="createDeeplink()">
                <v-icon class="mr-3">mdi-plus-circle-outline</v-icon>
                Create New Deep Link
              </v-btn>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="9" class="pt-0">
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table :headers="tableHeaders"
                              :items="deeplinks"
                              :no-data-text="nodata"
                              :options="options"
                              :footer-props="footer"
                              :search="search"
                              class="elevation-2 primary--text">
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      medium
                      class="mr-2 primary--text"
                      @click="copyDeeplink(item)">
                      mdi-content-copy
                    </v-icon>
                    <v-icon
                      medium
                      class="primary--text"
                      @click="deleteDeeplink(item)">
                      mdi-delete-outline
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { Banner } from '@nswdoe/doe-ui-core';

  export default {
    name: 'deeplinks',
    components: {
      Banner
    },
    data: () => ({
      tableHeaders: [
        { text: 'DisplayName', value: 'display_name', align: 'left' },
        { text: 'Key', value: 'key', align: 'left' },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ],
      options: {
        itemsPerPage: 5,
        sortBy: ['displayName'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true
      },
      footer: {
        itemsPerPageOptions: [5, 10, 20, -1],
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageAllText: "All",
      },
      nodata: 'No data found!',
      displayAlert: false,
      search: ''
    }),
    computed: {
      deeplinks() {
        return this.$store.state.deeplinks;
      },
      currentDeeplink() {
        return this.$store.state.deeplink;
      }
    },
    methods: {
      createDeeplink() {
        this.$router.push('/deeplinks/create');
      },
      copyDeeplink(deeplink) {
        this.$log.debug("copying deeplink", deeplink);
      },
      deleteDeeplink(deeplink) {
        this.$log.debug("deleting deeplink", deeplink);
      }
    },
    created () {
      if(this.$store.state.deeplinks.length === 0) {
        this.$store.dispatch('fetchDeeplinks').then(() => {
        }).catch(error => this.$log.error(error));
      }
    },


  }
</script>
